import { center } from '@onbeam/business-styled-system/patterns';
import { TooltipProps } from './Tooltip.types';
import * as TooltipPrimitive from '@radix-ui/react-tooltip';

export const Tooltip = ({
  children,
  label,
  width,
  delayDuration = 0,
  ...props
}: TooltipProps) => {
  return (
    <TooltipPrimitive.Provider delayDuration={delayDuration} {...props}>
      <TooltipPrimitive.Root>
        <TooltipPrimitive.TooltipTrigger asChild>
          {children}
        </TooltipPrimitive.TooltipTrigger>
        <TooltipPrimitive.Portal>
          <TooltipPrimitive.Content
            side="top"
            align="center"
            sideOffset={6}
            collisionPadding={4}
            className={center({
              zIndex: '50',
              overflow: 'hidden',
              bg: 'mono.primaryBg',
              rounded: '[1rem]',
              color: 'mono.primaryFg',
              p: '3',
              fontWeight: 'bold',
              textStyle: 'small-sm',
              textAlign: 'center',
              animationName: 'fadeIn',
              animationDuration: 'normal',

              _closed: {
                animationName: 'fadeOut',
              },
            })}
            style={{
              width,
            }}
          >
            {label}
            <TooltipPrimitive.Arrow width={14} height={7} />
          </TooltipPrimitive.Content>
        </TooltipPrimitive.Portal>
      </TooltipPrimitive.Root>
    </TooltipPrimitive.Provider>
  );
};
